// 动态设置Mate 的 SEO，目前是在app.vue调用，如果后面需要更改再改
export const usePrivateSeoMeta = () => {
  const runtimeConfig = useRuntimeConfig()
  // 页面Mate
  const metaPage = {
    // 通用页面
    all: {
      title:
        'Cocco - Meet new people and start wonderful entertainment game and chat',
      ogTitle:
        'Cocco - Meet new people and start wonderful entertainment game and chat',
      description:
        'Cocco Meet video chat with new people online ✔️ 1v1 chats ✔️online games✔️ support your favorite streamers ✔️make new friends',
      ogDescription:
        'Cocco Meet video chat with new people online ✔️ 1v1 chats ✔️online games✔️ support your favorite streamers ✔️make new friends',
      keywords:
        'Live Chat, meet new people, 1v1 video calls, online chatrooms, free video chat, webcam chat, random video chat, private video chat, cocco, Cocco，online games，gifts，entertainment，social',
      ogUrl: runtimeConfig.public.appleLoginRedirectUrl
    },
    // 主播首页
    home: {
      title: 'Cocco Discover - Video chat & real person dating',
      ogTitle: 'Cocco Discover - Video chat & real person dating',
      description:
        'In Cocco, you can choose someone for video dating, enjoy a sweet relationship, and accompany you to eliminate loneliness and worries. You will have a wonderful time.',
      ogDescription:
        'In Cocco, you can choose someone for video dating, enjoy a sweet relationship, and accompany you to eliminate loneliness and worries. You will have a wonderful time.',
      keywords:
        'real person dating,video chat,video dating,online dating,online chatrooms,1v1 chat,webcam chat, cocco, Cocco',
      ogUrl: runtimeConfig.public.appleLoginRedirectUrl + '/home'
    }
  }

  // 目前首页特殊，其他页面还是用常用的
  const route = useRoute()
  if (route.path === '/home') {
    useSeoMeta(metaPage.home)
  } else {
    useSeoMeta(metaPage.all)
  }
}
